import axios from 'axios';

export default {
  getCertificateWay(code) {
    return axios.get(`https://api.pfdo.ru/v2/main-page/certificate-ways/${code}`);
  },
};
